import React from 'react'
import { ContainerHeader, MainHealthProcedureDetailsContainer, SurgeryContent } from './styles'

import { ModalHeader } from '../../ModalComponents/ModalHeader'
import { ModalInformations } from '../../ModalComponents/ModalInformations'
import { ModalListProcedures } from '../../ModalComponents/ModalListProcedures'
import { ModalItemSurgicalProcedure } from '../../ModalComponents/ModalItemSurgicalProcedure'
import { ISurgery } from '~/interfaces'
import { formatMinutesInHours, replaceStringDashesBy } from '~/utils'

interface SurgeryDetailsContentProps {
  surgeryData: ISurgery
  renderRelatedAnatomopathologicalTests: () => JSX.Element
  renderRelatedMedicalNotes: () => JSX.Element
}

export const SurgeryDetailsContent = ({
  surgeryData,
  renderRelatedAnatomopathologicalTests,
  renderRelatedMedicalNotes
}: SurgeryDetailsContentProps): JSX.Element => {
  return (
    <MainHealthProcedureDetailsContainer>
      <ContainerHeader>
        <ModalHeader title={surgeryData?.description} datetime={surgeryData?.startDate} />
        <ModalInformations label="Cirurgião Principal" value={surgeryData?.mainSurgeon.name} />
        <ModalInformations label="Especialidade" value={surgeryData?.mainSurgeon.medicalSpecialty} />
        <ModalInformations
          label="Telefone(s)"
          value={replaceStringDashesBy(', ')(surgeryData?.mainSurgeon.phoneContact)}
        />
        <ModalInformations
          label="E-mail(s)"
          value={replaceStringDashesBy(', ')(surgeryData?.mainSurgeon.emailContact?.join(', '))}
        />
        <ModalInformations label="Duração" value={formatMinutesInHours(surgeryData?.durationInMinutes)} />
      </ContainerHeader>

      <SurgeryContent>
        <ModalListProcedures title={'Procedimentos Cirúrgicos'}>
          {surgeryData?.surgicalProcedures.map(_data => (
            <ModalItemSurgicalProcedure key={_data.tussId} tussId={_data.tussId} description={_data.description} />
          ))}
        </ModalListProcedures>

        {renderRelatedMedicalNotes()}
        {renderRelatedAnatomopathologicalTests()}
      </SurgeryContent>
    </MainHealthProcedureDetailsContainer>
  )
}
